import React from 'react'
import {Box, Text} from 'grommet'
import {
  BridgeOperation,
  BridgeOperationAction,
  BridgeOperationActionType,
  BridgeOperationStatus
} from "../../api/bridge";
import {Divider, Typography} from "antd";
import moment from "moment";
import {capitalizeFirstLetter, truncateEthAddress} from "../../utils";

const getBridgeActionAlias = (
  operation: BridgeOperation,
  action: BridgeOperationAction
) => {
  const { network } = operation
  switch(action.type) {
    case BridgeOperationActionType.approveEthManger: return 'User approve bridge to lock tokens'
    case BridgeOperationActionType.lockToken: return `Bridge lock tokens on ${capitalizeFirstLetter(network.toLowerCase())}`
    case BridgeOperationActionType.waitingBlockNumber: return `Wait for 13 block confirmations`
    case BridgeOperationActionType.mintToken: return `Bridge mint tokens on Harmony`
    default: return action.type
  }
}

export const BridgeAction = (props: {
  operation: BridgeOperation,
  action: BridgeOperationAction,
  index: number
}) => {
  const {index, action, operation} = props

  const actionAlias = getBridgeActionAlias(operation, action)

  return <Box>
    <Divider>{index}. {actionAlias}</Divider>
    <Box direction={'row'} justify={'between'}>
      <Box direction={'row'} gap={'6px'}>
        <Text>Status:</Text>
        <Text color={action.status === BridgeOperationStatus.success ? 'positiveValue' : 'unset'}>
          {capitalizeFirstLetter(action.status)}
        </Text>
      </Box>
      {action.timestamp &&
          <Text>{moment(action.timestamp * 1000).format('MMMM Do YYYY, h:mm:ss a')}</Text>
      }
    </Box>
    {action.transactionHash &&
        <Box direction={'row'} justify={'between'}>
            <Text>Txn hash</Text>
            <Typography.Text copyable={{ text: action.transactionHash }}>
              {truncateEthAddress(action.transactionHash)}
            </Typography.Text>
        </Box>
    }
  </Box>
}
